import React from 'react'

const AccessDenied = () => (
  <div className="container mt-5">
    <div className="row justify-content-center">
      <div className="col-md-6">
        <div className="alert alert-warning" role="alert">
          <div className="d-flex align-items-center mb-2">
            <i className="bi bi-shield-exclamation me-2"></i>
            <strong>Access Denied</strong>
          </div>
          <p className="mb-0">You need administrator privileges to access this content.</p>
        </div>
      </div>
    </div>
  </div>
)

export default AccessDenied